/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorWorkspaceDto } from '../../models/vendor-workspace-dto';

export interface VendorWorkspaceControllerSearchByNameOrBusinessNo$Params {
  query: string;
}

export function vendorWorkspaceControllerSearchByNameOrBusinessNo(http: HttpClient, rootUrl: string, params: VendorWorkspaceControllerSearchByNameOrBusinessNo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorWorkspaceDto>>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceControllerSearchByNameOrBusinessNo.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorWorkspaceDto>>;
    })
  );
}

vendorWorkspaceControllerSearchByNameOrBusinessNo.PATH = '/api/vendorWorkspace/search/vendor';
